export const muiStyles = () => ({
    root: { paddingTop: '1rem' },
    mapWalletContainer: {
        paddingLeft: '1rem',
        marginBottom: '.75rem'
    }
});